import cnLang from './home_cn.js'
import enLang from './home_en.js'

const cn = {
  home: cnLang
}

const en = {
  home: enLang
}

let current = (localStorage && localStorage.getItem('language')) || '中'
document.title = current === 'en' ? '4DKanKan' : '四维看看'

let languageObj = current === '中' ? cn : en

export default {
  state: {
    ...languageObj,
    current: current
  },
  mutations: {
    change_language (state, language) {
      let languageObj = language === '中' ? cn : en
      Object.keys(languageObj).forEach(key => {
        state[key] = languageObj[key]
      })
      state.current = language
      localStorage.setItem('language', language)
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/language/index.js